import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class GroupEmployee  {
    _originalTypeClassName = "zERP.BO.GroupEmployee";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
GroupEmployee.translate = translateService;
}
this.Employee = [];
this.Department = [];
this.Id = null;
this.Code = null;
this.Name = null;
this.Description = null;
this.Status = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Code:any;
Name:any;
Description:any;
Status:any;
Employee:any;
Department:any;
static setEmployee = ($this, items) => {
                if (items == null) items = [];
                if ($this.Employee == null) $this.Employee = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Employee.length > 0) {
                    Domain.GroupEmployee.removeEmployee($this, $this.Employee[0]);
                }

                Domain.GroupEmployee.addManyEmployee($this, copyItems);
            }
static addManyEmployee = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GroupEmployee.addEmployee($this, items[i]);
                }
            }
static addEmployee = ($this, item) => {
                if ($this.Employee == null) $this.Employee = [];
                if (item == null || $this.Employee.indexOf(item) > -1) return;
                $this.Employee.push(item);
}
static addRangeEmployee = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GroupEmployee.addEmployee($this, item));
            }
static removeEmployee = ($this, item) => {
                if ($this == null || $this.Employee == null || $this.Employee.indexOf(item) === -1) return;
                var _index = $this.Employee.indexOf(item);
                $this.Employee.splice(_index, 1);
}
static clearEmployee = ($this) => { $this.Employee = null; }
static setDepartment = ($this, items) => {
                if (items == null) items = [];
                if ($this.Department == null) $this.Department = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Department.length > 0) {
                    Domain.GroupEmployee.removeDepartment($this, $this.Department[0]);
                }

                Domain.GroupEmployee.addManyDepartment($this, copyItems);
            }
static addManyDepartment = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.GroupEmployee.addDepartment($this, items[i]);
                }
            }
static addDepartment = ($this, item) => {
                if ($this.Department == null) $this.Department = [];
                if (item == null || $this.Department.indexOf(item) > -1) return;
                $this.Department.push(item);
}
static addRangeDepartment = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.GroupEmployee.addDepartment($this, item));
            }
static removeDepartment = ($this, item) => {
                if ($this == null || $this.Department == null || $this.Department.indexOf(item) === -1) return;
                var _index = $this.Department.indexOf(item);
                $this.Department.splice(_index, 1);
}
static clearDepartment = ($this) => { $this.Department = null; }

static CreateNotificationTask($this: any, step: any): any{}
static GetClassName(): any{return "GroupEmployee";
}

static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}